var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 22C15.2614 22 17.7614 20.8807 19.5711 19.0711C21.3807 17.2614 22.5 14.7614 22.5 12C22.5 9.2386 21.3807 6.7386 19.5711 4.92893C17.7614 3.11929 15.2614 2 12.5 2C9.7386 2 7.2386 3.11929 5.42893 4.92893C3.61929 6.7386 2.5 9.2386 2.5 12C2.5 14.7614 3.61929 17.2614 5.42893 19.0711C7.2386 20.8807 9.7386 22 12.5 22Z",
    stroke: "#2A3D4A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.3125V12.3125C14.1568 12.3125 15.5 10.9694 15.5 9.3125C15.5 7.65565 14.1568 6.3125 12.5 6.3125C10.8432 6.3125 9.5 7.65565 9.5 9.3125",
    stroke: "#2A3D4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17.5625C13 17.8386 12.7761 18.0625 12.5 18.0625C12.2239 18.0625 12 17.8386 12 17.5625C12 17.2864 12.2239 17.0625 12.5 17.0625C12.7761 17.0625 13 17.2864 13 17.5625Z",
    fill: "#2A3D4A",
    stroke: "#2A3D4A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBlack);
export default __webpack_public_path__ + "static/media/question-black.0c1ff6f849792afb6775f1d3c8c029ce.svg";
export { ForwardRef as ReactComponent };